/* ────────────────────────────────────────────────────────────────────
 * About Prinotes (English).
 *
 * A lean disclosure page. Its primary job is to carry the Saudi E-Commerce
 * Law disclosures (MoC Trader's Guide p.8): legal-entity name, commercial
 * register identifier (the establishment's National Number), location,
 * contact information, a Privacy Policy link, and a claims-handling route
 * (Support). No VAT/Tax ID is shown because Priyora is not VAT-registered
 * yet (see Terms §10). Arabic mirror lives in about-ar.ts.
 * ──────────────────────────────────────────────────────────────────── */

export interface AboutDetail {
  label: string;
  value: string;
}

export interface AboutContact {
  label: string;
  email: string;
}

export interface AboutDoc {
  eyebrow: string;
  title: string;
  intro: string[];
  detailsHeading: string;
  details: AboutDetail[];
  contactHeading: string;
  contactIntro: string;
  contacts: AboutContact[];
  privacyBefore: string;
  privacyLinkLabel: string;
  privacyAfter: string;
}

export const ABOUT_EN: AboutDoc = {
  eyebrow: 'Company',
  title: 'About Prinotes',
  intro: [
    'Prinotes is an AI workspace that transcribes your conversations and meetings into organized notes tailored to you, and lets you record the audio of your conversations and meetings and manage your events and tasks, with complete privacy and security.',
    'Prinotes is developed by Priyora Company, a Saudi company based in Jeddah. We build Prinotes in compliance with Saudi Arabia’s Personal Data Protection Law (PDPL).',
  ],
  detailsHeading: 'Company details',
  details: [
    { label: 'Legal entity', value: 'Priyora Company, a single-member Limited Liability Company (LLC)' },
    { label: 'Unified National Number', value: '7053899808' },
    { label: 'Location', value: 'Jeddah, Kingdom of Saudi Arabia' },
  ],
  contactHeading: 'Contact',
  contactIntro: 'For general enquiries, contact us through the general address. For specific requests, use the dedicated address for that purpose:',
  contacts: [
    { label: 'General enquiries', email: 'info@prinotes.com' },
    { label: 'Support', email: 'support@prinotes.com' },
    { label: 'Privacy', email: 'privacy@prinotes.com' },
  ],
  privacyBefore: 'To learn how we collect, use, and protect your data, see our ',
  privacyLinkLabel: 'Privacy Policy',
  privacyAfter: '.',
};
